/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FileUrl } from '../../models/file-url';

export interface ApiMessageFileFileIdGet$Params {
  file_id: number;
}

export function apiMessageFileFileIdGet(http: HttpClient, rootUrl: string, params: ApiMessageFileFileIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<FileUrl>> {
  const rb = new RequestBuilder(rootUrl, apiMessageFileFileIdGet.PATH, 'get');
  if (params) {
    rb.path('file_id', params.file_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FileUrl>;
    })
  );
}

apiMessageFileFileIdGet.PATH = '/api/message/file/{file_id}';
